import { Link, useRouteMatch } from "react-router-dom";
import ArrowForwardIosIcon from "@material-ui/icons/ArrowForwardIos";

export default function CategoryTopTable({ setSearchBy, setValue }) {
  let match = useRouteMatch();
  return (
    <div className="bg-blue-900 text-white relative flex flex-col min-w-0 break-words w-full shadow-lg rounded">
      <div className="flex flex-col max-w-full shadow-md m-6">
        <div className="flex justify-between items-center bg-gray-50 border-b px-6 py-4">
          <div>
            <p className="text-xl text-white font-semibold">Stock Category</p>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                marginTop: "1rem",
              }}
            >
              <Link
                to="/admin/dashboard"
                className="text-white text-sm hover:text-gray-200 lg:inline-block font-semibold"
              >
                DASHBOARD
              </Link>
              <ArrowForwardIosIcon
                style={{ color: "white", fontSize: "12px", margin: "0 1rem" }}
              />
              <Link
                to="/admin/file-maintainance"
                className="text-white text-sm hover:text-gray-200 lg:inline-block font-semibold"
              >
                FILE MAINTAINANCE
              </Link>
              <ArrowForwardIosIcon
                style={{ color: "white", fontSize: "12px", margin: "0 1rem" }}
              />
              <span
                className="text-sm uppercase hidden lg:inline-block font-semibold"
                style={{ color: "#90cdf4" }}
              >
                STOCK CATEGORY
              </span>
            </div>
          </div>

          <Link
            to={`${match.url}/add`}
            className="bg-yellow-500 hover:bg-yellow-400 text-white text-xs px-6 py-2 rounded-lg border-0"
          >
            Add Stock Category
          </Link>
        </div>

        <div className="flex flex-wrap justify-between items-center bg-blue-900 border-b p-2 space-y-2 md:space-y-0">
          <div className="space-x-1 mb-1 sm:mb-0">
            <button className="border border-gray-300 shadow-sm rounded-md p-3">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
                className="h-4 w-4 text-gray-500"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-8l-4-4m0 0L8 8m4-4v12"
                />
              </svg>
            </button>
          </div>

          <div className="flex flex-wrap justify-start md:justify-end items-center space-x-0 space-y-2 sm:space-x-2 sm:space-y-0">
            <div className="relative" style={{ marginRight: "1rem" }}>
              <input
                type="text"
                placeholder="Search by"
                onChange={(e) => setValue(e.target.value)}
                className="appearance-none relative block w-full px-8 py-2 border border-gray-300 placeholder-gray-500 text-gray-800 shadow-sm rounded-md focus:outline-none focus:ring-gray-500 focus:border-gray-500 focus:z-10 text-xs"
                style={{
                  padding: ".5rem 2rem",
                  borderRadius: ".5rem",
                  marginRight: "2rem",
                }}
              />

              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
                className="absolute left-3 bottom-2 h-4 w-8 text-gray-500"
                style={{
                  left: "14rem",
                  bottom: ".1rem",
                }}
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
                />
              </svg>
            </div>
            <select
              type="text"
              className="placeholder-gray-400 text-gray-700 bg-white text-sm shadow focus:outline-none focus:shadow-outline  ease-linear transition-all duration-150"
              style={{
                padding: ".5rem ",
                width: "200px",
                cursor: "pointer",
                marginRight: "1rem",
              }}
              name="category"
              onChange={(e) => setSearchBy(e.target.value)}
            >
              <option value="">Filter</option>
              <option value="Name">Name</option>
            </select>
          </div>
        </div>
      </div>
    </div>
  );
}
